import noop from 'lodash/noop';
import Vue from 'vue';
import routes from './routes';
import VueRouter from 'vue-router';
import type { RouteConfig, RawLocation, Location } from 'vue-router/types/router';

Vue.use(VueRouter);

export const isLocation = (to: RawLocation): to is Location => {
  return typeof to !== 'string';
};

const router = new VueRouter({
  mode: 'history',
  routes: routes as RouteConfig[],
});

console.log('Initialized Vue 2 router');

export const addQueryParamsWithoutReload = async (
  params: Record<string, string>,
  _router: VueRouter
) => {
  return _router
    .replace({
      path: router.currentRoute.path,
      query: {
        ...router.currentRoute.query,
        ...params,
      },
    })
    .catch(noop);
};

export function getGlobalRouter(): VueRouter {
  return router;
}
